import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=c35c446c&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"
import style0 from "./PageView.vue?vue&type=style&index=0&id=c35c446c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35c446c",
  null
  
)

export default component.exports